import { MasteryType } from '@/lib/fetchMastery';
import TableSkeleton from './Skeleton';

interface TableProps {
  MAX_MASTERY_COUNT: number;
  results: MasteryType[];
  loading?: boolean;
}

const Table = ({ MAX_MASTERY_COUNT, results, loading }: TableProps) => {
  if (loading) {
    <TableSkeleton />;
  }

  return (
    <div className='overflow-x-auto relative mastery-dashboard'>
      <table className='w-full text-xs sm:text-sm md:text-base lg:text-lg text-left text-gray-500 dark:text-gray-400'>
        <thead className='text-xs sm:text-sm md:text-base lg:text-lg text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400'>
          <tr className='bg-blue-50'>
            <th scope='col' className=' py-3 px-2 sm:px-4 md:px-6 text-left bg-blue-200 dark:bg-blue-800 text-blue-900 dark:text-blue-200 font-bold font-raleway'>
              Topic
            </th>
            {MAX_MASTERY_COUNT ? (
              Array.from({ length: MAX_MASTERY_COUNT }, (_, i) => (
                <th scope='col' className='bg-blue-200 py-3 px-2 sm:px-4 md:px-6 text-center' key={i}>
                  Mastery #{i + 1}
                </th>
              ))
            ) : (
              <th scope='col' className='bg-blue-200 py-3 px-2 sm:px-4 md:px-6 text-center'>
                Status
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {results?.length > 0 ? (
            results?.map((mastery, index) => (
              <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700' key={index}>
                <th scope='row' className=' py-4 px-2 sm:px-4 md:px-6 font-medium text-left bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200'>
                  <a href={mastery.post_link} target='_blank' className='hover:underline'>
                    {mastery.title}
                  </a>
                </th>
                {parseInt(mastery.isMastered) == 1 ? (
                  <td colSpan={MAX_MASTERY_COUNT} className='py-4 px-2 sm:px-4 md:px-6 text-center bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 font-semibold text-xl'>
                    <div className='flex flex-row flex-nowrap justify-center items-center' style={{ gap: '30px' }}>
                      <img src='./star.svg' alt='mastery icon' className='w-5 h-5' />
                      Mastered
                      <img src='./star.svg' alt='mastery icon' className='w-5 h-5' />
                    </div>
                  </td>
                ) : (
                  Array.from({ length: MAX_MASTERY_COUNT }, (_, idx) => (
                    <td className='py-4 px-2 sm:px-4 md:px-6 text-xl text-center' key={idx}>
                      {parseInt(mastery.total_attempts, 10) > idx ? <span className='text-green-500 dark:text-green-400 font-bold'>✅</span> : <span className='text-gray-500 dark:text-gray-400'>⬜</span>}
                    </td>
                  ))
                )}
              </tr>
            ))
          ) : (
            <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
              <td colSpan={MAX_MASTERY_COUNT == 0 ? 2 : MAX_MASTERY_COUNT + 1} className='py-4 px-2 sm:px-4 md:px-6 text-center text-gray-700 dark:text-gray-400 font-bold text-xl'>
                No Data
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
